import { useMeta } from '@/hooks/useMeta';

export default function TermsOfService() {
  useMeta({
    title: 'Terms of Service | AmericanTrademark Firm',
    description: 'Review AmericanTrademark Firm\'s Terms of Service. Understand your rights and responsibilities when using our trademark registration and IP protection services.',
    keywords: 'terms of service, terms and conditions, service agreement, AmericanTrademark Firm terms',
  });

  return (
    <div data-testid="terms-page">
      <section className="relative py-24 md:py-36 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1521791055366-0d553872125f?w=1920&q=80)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#09090B]/80 via-[#09090B]/65 to-[#09090B]/40" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#6B9FFF] mb-4">Legal</p>
          <h1 className="font-heading font-black text-5xl md:text-6xl tracking-tighter leading-none text-white">
            Terms of Service
          </h1>
        </div>
      </section>
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-12 font-body text-zinc-600 leading-relaxed space-y-8">
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Acceptance of Terms</h2>
            <p>By accessing and using the AmericanTrademark Firm website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or services.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Services Description</h2>
            <p>AmericanTrademark Firm provides trademark registration, copyright protection, patent filing, company formation, and related intellectual property services. Our services are designed to assist businesses and individuals in protecting their intellectual property rights within the United States.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">User Responsibilities</h2>
            <p className="mb-3">When using our services, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide accurate and complete information in all forms and applications</li>
              <li>Respond promptly to requests for additional information</li>
              <li>Not use our services for any unlawful purpose</li>
              <li>Maintain the confidentiality of your account information</li>
            </ul>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Payment Terms</h2>
            <p>Service fees are due at the time of service engagement. Government filing fees are separate from our service fees and are subject to change by the relevant government agency. All fees are non-refundable unless otherwise stated in your service agreement.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Limitation of Liability</h2>
            <p>While we strive to provide the highest quality service, we cannot guarantee the approval of any trademark, copyright, or patent application. Government agencies make independent decisions on applications. Our liability is limited to the fees paid for our services.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Intellectual Property</h2>
            <p>All content on our website, including text, graphics, logos, and software, is the property of AmericanTrademark Firm and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works from our content without prior written consent.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Dispute Resolution</h2>
            <p>Any disputes arising from the use of our services shall be resolved through binding arbitration in accordance with the laws of the United States. Both parties agree to attempt to resolve disputes through good-faith negotiation before pursuing arbitration.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Modifications</h2>
            <p>We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting on our website. Your continued use of our services after any modifications constitutes acceptance of the updated terms.</p>
          </div>
          <div>
            <h2 className="font-heading font-bold text-2xl text-[#09090B] mb-4">Contact</h2>
            <p>For questions regarding these Terms of Service, please reach out through our Contact Us page.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
